import {Component, Input, OnInit, TemplateRef} from '@angular/core';
import {CustomerProfile} from '../../../../domain/customer/customer-profile';
import {MediaAccessStatus} from '../../../../domain/accounts/media-access';
import {ApplicationStatus} from '../../../../domain/onBoarding/application-body';
import {AccountConfiguration} from '../../../../domain/configurations';
import {CustomerStatus} from '../../../../domain/customer/customer-detail';
import {FamilyHealthStatus} from '../../../../enums/family-health-status.enum';
import {FamilyHealthService} from '../../../../services/family-health.service';
import {CommonComponent, ModalSize} from '../../../shared/common/common.component';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NotificationsService} from "../../../../services/notifications.service";
import {ToastaService} from "ngx-toasta";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {DialogService} from "primeng/dynamicdialog";
import {AccountService} from "../../../../services/account.service";

@Component({
  selector: 'app-balance-notifications',
  templateUrl: './balance-notifications.component.html',
  styleUrls: ['./balance-notifications.component.scss']
})
export class BalanceNotificationsComponent extends CommonComponent implements OnInit {
  @Input() profileDetail: CustomerProfile;
  @Input() configuration: AccountConfiguration;
  @Input() familyHealthService: FamilyHealthService;
  @Input() emailValidation: boolean;
  eMediaAccessStatus = MediaAccessStatus;
  eApplicationStatus = ApplicationStatus;
  eCustomerStatus = CustomerStatus;
  eFamilyHealthStatus = FamilyHealthStatus;
  webPage = null;
  constructor(protected modalService: NgbModal,
              protected notificationsService: NotificationsService,
              protected toastService: ToastaService,
              protected router: Router,
              public translate: TranslateService,
              protected dialogService: DialogService,
              protected accountService: AccountService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
  }

  ngOnInit(): void {
  }

  sendEmailConfirmation() {
    this.loadingModalOn();
    this.accountService.sendConfirmationEmail().subscribe(
      (response: any) => {
        this.msgSuccess(this.translate.instant('accounts.balance.notifications.send_email_success'));
        this.emailValidation = false;
        this.loadingModalOff();
      }, error => {
        this.msgError(error, this.translate.instant('accounts.balance.notifications.send_email_error'));
        this.loadingModalOff();
      }
    );
  }

}
